// 提交提醒
export function submitHint() {
  this.$notify({
    title: "内容提交成功！等待审核通过后发布",
    message: "可在审核中心查看审核状态",
    type: "warning",
  })
}

